<template>
  <div class="app-main-inner" style="flex-grow: 1;">
    <customer-vendor-rating-layout :element-blocks="elementBlocks">
      <el-form-item v-if="elementDict.subscribedPaidCapital && elementDict.subscribedPaidCapital.viewable" slot="subscribedPaidCapital" style="width: calc(25% - 15px);margin-right: 10px;">
        <line-label slot="label" :class="elementDict.subscribedPaidCapital.isRequire ? 'blue' : ''" :label="elementDict.subscribedPaidCapital.label" />
        <el-select
          :value="form.subscribedPaidCapital"
          :disabled="readonly || !elementDict.subscribedPaidCapital.writable"
          style="width:200px"
          clearable
          no="subscribedPaidCapital"
          @input="val=>{form.subscribedPaidCapital=val}"
          @change="dataChange"
        >
          <el-option
            v-for="item in SystemConstants.CAPITAL_LIST"
            :key="item.code"
            :label="$store.getters.language === 'zh'?item.chineseName:item.englishName"
            :value="item.code"
          />
        </el-select>
      </el-form-item>
      <el-form-item v-if="elementDict.taxpayerCreditLevel && elementDict.taxpayerCreditLevel.viewable" slot="taxpayerCreditLevel" style="width: calc(25% - 15px);margin-right: 10px;">
        <line-label slot="label" :class="elementDict.taxpayerCreditLevel.isRequire ? 'blue' : ''" :label="elementDict.taxpayerCreditLevel.label" />
        <el-select
          :value="form.taxpayerCreditLevel"
          :disabled="readonly || !elementDict.taxpayerCreditLevel.writable"
          style="width:200px"
          clearable
          no="taxpayerCreditLevel"
          @input="val=>{form.taxpayerCreditLevel=val}"
          @change="dataChange"
        >
          <el-option
            v-for="item in SystemConstants.TAX_LIST"
            :key="item.code"
            :label="$store.getters.language === 'zh'?item.chineseName:item.englishName"
            :value="item.code"
          />
        </el-select>
      </el-form-item>
      <el-form-item v-if="elementDict.enterpriseNature && elementDict.enterpriseNature.viewable" slot="enterpriseNature" style="width: calc(25% - 15px);margin-right: 10px;">
        <line-label slot="label" :class="elementDict.enterpriseNature.isRequire ? 'blue' : ''" :label="elementDict.enterpriseNature.label" />
        <el-select
          :value="form.enterpriseNature"
          :disabled="readonly || !elementDict.enterpriseNature.writable"
          style="width:200px"
          clearable
          no="enterpriseNature"
          @input="val=>{form.enterpriseNature=val}"
          @change="dataChange"
        >
          <el-option
            v-for="item in SystemConstants.NATURE_LIST"
            :key="item.code"
            :label="$store.getters.language === 'zh'?item.chineseName:item.englishName"
            :value="item.code"
          />
        </el-select>
      </el-form-item>
      <el-form-item v-if="elementDict.businessPremisesNature && elementDict.businessPremisesNature.viewable" slot="businessPremisesNature" style="width: calc(25% - 15px);margin-right: 10px;">
        <line-label slot="label" :class="elementDict.businessPremisesNature.isRequire ? 'blue' : ''" :label="elementDict.businessPremisesNature.label" />
        <el-select
          :value="form.businessPremisesNature"
          :disabled="readonly || !elementDict.businessPremisesNature.writable"
          style="width:200px"
          clearable
          no="businessPremisesNature"
          @input="val=>{form.businessPremisesNature=val}"
          @change="dataChange"
        >
          <el-option
            v-for="item in SystemConstants.VENUE_LIST"
            :key="item.code"
            :label="$store.getters.language === 'zh'?item.chineseName:item.englishName"
            :value="item.code"
          />
        </el-select>
      </el-form-item>
      <el-form-item v-if="elementDict.cooperationYearsContinuity && elementDict.cooperationYearsContinuity.viewable" slot="cooperationYearsContinuity" style="width: calc(25% - 15px);margin-right: 10px;">
        <line-label slot="label" :class="elementDict.cooperationYearsContinuity.isRequire ? 'blue' : ''" :label="elementDict.cooperationYearsContinuity.label" />
        <el-select
          :value="form.cooperationYearsContinuity"
          :disabled="readonly || !elementDict.cooperationYearsContinuity.writable"
          style="width:200px"
          clearable
          no="cooperationYearsContinuity"
          @input="val=>{form.cooperationYearsContinuity=val}"
          @change="dataChange"
        >
          <el-option
            v-for="item in SystemConstants.COOP_LIST"
            :key="item.code"
            :label="$store.getters.language === 'zh'?item.chineseName:item.englishName"
            :value="item.code"
          />
        </el-select>
      </el-form-item>
      <el-form-item v-if="elementDict.estimatedReceivableDays && elementDict.estimatedReceivableDays.viewable" slot="estimatedReceivableDays" style="width: calc(25% - 15px);margin-right: 10px;">
        <line-label slot="label" :class="elementDict.estimatedReceivableDays.isRequire ? 'blue' : ''" :label="elementDict.estimatedReceivableDays.label" />
        <el-select
          :value="form.estimatedReceivableDays"
          :disabled="readonly || !elementDict.estimatedReceivableDays.writable"
          style="width:200px"
          clearable
          no="estimatedReceivableDays"
          @input="val=>{form.estimatedReceivableDays=val}"
          @change="dataChange"
        >
          <el-option
            v-for="item in SystemConstants.AR_DAYS_LIST"
            :key="item.code"
            :label="$store.getters.language === 'zh'?item.chineseName:item.englishName"
            :value="item.code"
          />
        </el-select>
      </el-form-item>
      <el-form-item v-if="elementDict.estimatedMonthlyAmount && elementDict.estimatedMonthlyAmount.viewable" slot="estimatedMonthlyAmount" style="width: calc(25% - 15px);margin-right: 10px;">
        <line-label slot="label" :class="elementDict.estimatedMonthlyAmount.isRequire ? 'blue' : ''" :label="elementDict.estimatedMonthlyAmount.label" />
        <el-select
          :value="form.estimatedMonthlyAmount"
          :disabled="readonly || !elementDict.estimatedMonthlyAmount.writable"
          style="width:200px"
          clearable
          no="estimatedMonthlyAmount"
          @input="val=>{form.estimatedMonthlyAmount=val}"
          @change="dataChange"
        >
          <el-option
            v-for="item in SystemConstants.AR_AMT_LIST"
            :key="item.code"
            :label="$store.getters.language === 'zh'?item.chineseName:item.englishName"
            :value="item.code"
          />
        </el-select>
      </el-form-item>
      <el-form-item v-if="elementDict.estimatedGrossProfitContribution && elementDict.estimatedGrossProfitContribution.viewable" slot="estimatedGrossProfitContribution" style="width: calc(25% - 15px);margin-right: 10px;">
        <line-label slot="label" :class="elementDict.estimatedGrossProfitContribution.isRequire ? 'blue' : ''" :label="elementDict.estimatedGrossProfitContribution.label" />
        <el-select
          :value="form.estimatedGrossProfitContribution"
          :disabled="readonly || !elementDict.estimatedGrossProfitContribution.writable"
          style="width:200px"
          clearable
          no="estimatedGrossProfitContribution"
          @input="val=>{form.estimatedGrossProfitContribution=val}"
          @change="dataChange"
        >
          <el-option
            v-for="item in SystemConstants.MARGIN_LIST"
            :key="item.code"
            :label="$store.getters.language === 'zh'?item.chineseName:item.englishName"
            :value="item.code"
          />
        </el-select>
      </el-form-item>
      <el-form-item v-if="elementDict.customerNature && elementDict.customerNature.viewable" slot="customerNature" style="width: calc(25% - 15px);margin-right: 10px;">
        <line-label slot="label" :class="elementDict.customerNature.isRequire ? 'blue' : ''" :label="elementDict.customerNature.label" />
        <el-select
          :value="form.customerNature"
          :disabled="readonly || !elementDict.customerNature.writable"
          style="width:200px"
          clearable
          no="customerNature"
          @input="val=>{form.customerNature=val}"
          @change="dataChange"
        >
          <el-option
            v-for="item in SystemConstants.CUSTOMER_TYPE_LIST"
            :key="item.code"
            :label="$store.getters.language === 'zh'?item.chineseName:item.englishName"
            :value="item.code"
          />
        </el-select>
      </el-form-item>
      <el-form-item v-if="elementDict.industryExtraQualificationsAwards && elementDict.industryExtraQualificationsAwards.viewable" slot="industryExtraQualificationsAwards" style="width: calc(25% - 15px);margin-right: 10px;">
        <line-label slot="label" :class="elementDict.industryExtraQualificationsAwards.isRequire ? 'blue' : ''" :label="elementDict.industryExtraQualificationsAwards.label" />
        <el-select
          :value="form.industryExtraQualificationsAwards"
          :disabled="readonly || !elementDict.industryExtraQualificationsAwards.writable"
          style="width:200px"
          clearable
          no="industryExtraQualificationsAwards"
          @input="val=>{form.industryExtraQualificationsAwards=val}"
          @change="dataChange"
        >
          <el-option
            v-for="item in SystemConstants.QUALITY_LIST"
            :key="item.code"
            :label="$store.getters.language === 'zh'?item.chineseName:item.englishName"
            :value="item.code"
          />
        </el-select>
      </el-form-item>
      <div v-show="elementDict.totalScore && elementDict.totalScore.viewable" key="totalScore" slot="totalScore">
        <el-form-item v-if="elementDict.totalScore && elementDict.totalScore.viewable" slot="totalScore" style="width: calc(25% - 15px);margin-right: 10px;">
          <line-label slot="label" :class="elementDict.totalScore.isRequire ? 'blue' : ''" :label="elementDict.totalScore.label" />
          <auto-number-input
            v-model="form.totalScore"
            no="totalScore"
            :precision="0"
            :min="0"
            style="width:200px"
            :disabled="true"
          />
        </el-form-item>
      </div>
      <div v-show="elementDict.totalScore && elementDict.totalScore.viewable" key="totalScore1" slot="totalScore" style="background-color: rgb(230 227 228);height: 2px;" />
      <el-form-item v-if="elementDict.procurementType && elementDict.procurementType.viewable" slot="procurementType" style="width: calc(25% - 15px);margin-right: 10px;">
        <line-label slot="label" :class="elementDict.procurementType.isRequire ? 'blue' : ''" :label="elementDict.procurementType.label" />
        <el-select
          :value="form.procurementType"
          :disabled="readonly || !elementDict.procurementType.writable"
          style="width:200px"
          clearable
          no="procurementType"
          @input="val=>{form.procurementType=val}"
          @change="dataChange"
        >
          <el-option
            v-for="item in SystemConstants.PROCUREMENT_TYPE_LIST"
            :key="item.code"
            :label="$store.getters.language === 'zh'?item.chineseName:item.englishName"
            :value="item.code"
          />
        </el-select>
      </el-form-item>
      <el-form-item v-if="elementDict.supplierQuotation && elementDict.supplierQuotation.viewable" slot="supplierQuotation" style="width: calc(25% - 15px);margin-right: 10px;">
        <line-label slot="label" :class="elementDict.supplierQuotation.isRequire ? 'blue' : ''" :label="elementDict.supplierQuotation.label" />
        <auto-number-input
          v-model="form.supplierQuotation"
          no="supplierQuotation"
          :precision="2"
          :min="0"
          style="width:200px"
          :disabled="readonly"
        />
      </el-form-item>
      <el-form-item v-if="elementDict.intendedSupplier && elementDict.intendedSupplier.viewable" slot="intendedSupplier" style="width: calc(25% - 15px);margin-right: 10px;">
        <line-label slot="label" :class="elementDict.intendedSupplier.isRequire ? 'blue' : ''" :label="elementDict.intendedSupplier.label" />
        <el-select
          :value="form.intendedSupplier"
          :disabled="readonly || !elementDict.intendedSupplier.writable"
          style="width:200px"
          clearable
          no="intendedSupplier"
          @input="val=>{form.intendedSupplier=val}"
          @change="dataChange"
        >
          <el-option
            v-for="item in SystemConstants.YESORNO_COMMON_STATES"
            :key="item.code"
            :label="$store.getters.language === 'zh'?item.chineseName:item.englishName"
            :value="Boolean(item.code)"
          />
        </el-select>
      </el-form-item>
    </customer-vendor-rating-layout>
  </div>
</template>

<script>
import { TabError } from '@/utils/class/TabError'
import customerVendorRatingLayout from '@/views/cargo/v0/Information/components/partner/tab/customerVendorRatingLayout.vue'
import * as UICustomConstants from '@/class/cargo/model/parameters/UICustomConstants'
import { UICustomUtil } from '@/class/cargo/model/utils/UICustomUtil'
import StrUtils from '@/utils/StrUtils'
import cargoAdvanceSelect from '@/components/Cargo/Common/cargoAdvanceSelect.vue'
import * as SystemConstants from '@/class/cargo/model/parameters/SystemConstants'
import AutoNumberInput from '@/components/Cargo/Common/AutoNumberInput.vue'
import { getCustomerVendorRatingFunc } from '@/api/company'
import { PriceUtils } from '@/class/cargo/model/utils/PriceUtils'
import $store from '@/store'

export default {
  name: 'CustomerVendorRating',
  components: { AutoNumberInput, cargoAdvanceSelect, customerVendorRatingLayout },
  props: {
    previewConfig: { type: Object, default: null },
    action: { type: String, required: true }
  },
  data() {
    return {
      company: {},
      form: {
        uuid: '',
        version: 0,
        branchId: '',
        cmpIdx: '',
        companyUuid: '',
        subscribedPaidCapital: '',
        taxpayerCreditLevel: '',
        enterpriseNature: '',
        businessPremisesNature: '',
        cooperationYearsContinuity: '',
        estimatedReceivableDays: '',
        estimatedMonthlyAmount: '',
        estimatedGrossProfitContribution: '',
        customerNature: '',
        industryExtraQualificationsAwards: '',
        totalScore: 0.0,
        procurementType: '',
        supplierQuotation: 0.0,
        intendedSupplier: false
      },
      elementBlocks: [],
      elementDict: {},
      fieldDict: {}
    }
  },
  computed: {
    readonly() {
      return !this.action || this.action === 'look'
    },
    SystemConstants() {
      return SystemConstants
    }
  },
  watch: {
    '$store.getters.currentOfficeId': {
      handler() {
        this.loadPageConfig()
      }
    }
  },
  created() {
    this.loadPageConfig()
  },
  methods: {
    async onShow(row, isRefresh) {
      if (isRefresh) {
        this.company = row
        this.queryData()
        UICustomUtil.handleViewAndWrite(UICustomConstants.COMPANY_NATIVE_CUSTOMER_VENDOR_RATING, this.elementDict, row)
      }
    },
    queryData() {
      if (!this.company.uuid) {
        this.form = PriceUtils.resetFilter(this.form)
        return
      }
      getCustomerVendorRatingFunc({ companyUuid: this.company.uuid }).then(res => {
        if (res.data) {
          this.form = res.data
        } else {
          this.form = PriceUtils.resetFilter(this.form)
        }
      })
    },
    loadPageConfig() {
      if (this.previewConfig) {
        this.elementBlocks = this.previewConfig.elementBlocks
        this.elementDict = this.previewConfig.elementDict
        this.fieldDict = this.previewConfig.fieldDict
      } else {
        const pageConfig = UICustomUtil.getPageConfig(UICustomConstants.COMPANY_NATIVE_CUSTOMER_VENDOR_RATING, this.$store.getters.currentOfficeId)
        if (!pageConfig.elementBlocks || pageConfig.elementBlocks.length === 0) {
          this.doIndexPage(this.$store.getters.currentOfficeId)
        } else {
          this.elementBlocks = pageConfig.elementBlocks
          this.elementDict = pageConfig.elementDict
          this.fieldDict = pageConfig.fieldDict
        }
      }
    },
    async doIndexPage(branchId) {
      // 处理首页第一次打开页面情况
      await Promise.all([
        $store.dispatch('uiCustom/loadUICustomPageInfo', { pageType: UICustomConstants.COMPANY_NATIVE_CUSTOMER_VENDOR_RATING, branchId })
      ])
      const pageConfig = UICustomUtil.getPageConfig(UICustomConstants.COMPANY_NATIVE_CUSTOMER_VENDOR_RATING, this.$store.getters.currentOfficeId)
      this.elementBlocks = pageConfig.elementBlocks
      this.elementDict = pageConfig.elementDict
      this.fieldDict = pageConfig.fieldDict
    },
    validateForm(form) {
      for (const name in this.elementDict) {
        const element = this.elementDict[name]
        if (!element.viewable || !element.writable || !element.isRequire) {
          continue
        }
        if (!element.fieldNames) {
          continue
        }
        for (const fieldName of element.fieldNames) {
          const field = this.fieldDict[fieldName]
          const label = element.fieldNames.length > 1 ? field.label : element.label
          if (typeof form[fieldName] !== 'boolean' && StrUtils.isEmpty(form[fieldName])) {
            throw new TabError(this.$t('Message.FieldValueCannotBeNull', [label]), 'customerVendorRating')
          }
        }
      }
    },
    dataChange() {
      const n1 = this.form.subscribedPaidCapital || 0
      const n2 = this.form.taxpayerCreditLevel || 0
      const n3 = this.form.enterpriseNature || 0
      const n4 = this.form.businessPremisesNature || 0
      const n5 = this.form.cooperationYearsContinuity || 0
      const n6 = this.form.estimatedReceivableDays || 0
      const n7 = this.form.estimatedMonthlyAmount || 0
      const n8 = this.form.estimatedGrossProfitContribution || 0
      const n9 = this.form.customerNature || 0
      const n10 = this.form.industryExtraQualificationsAwards || 0
      this.form.totalScore = Number(n1) + Number(n2) + Number(n3) + Number(n4) + Number(n5) + Number(n6) + Number(n7) +
        Number(n8) + Number(n9) + Number(n10)
    },
    getSubmitData() {
      this.validateForm(this.form)
      this.form.branchId = this.$store.getters.currentOfficeId
      return {
        customerVendorRating: this.form
      }
    }
  }
}
</script>
